import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Footer from "./Footer";
import Post from "./Post";
import samplePosts from "../sample-posts";
import ContentManagement from "./ContentManagement";
import base from "../base";

class App extends React.Component {
  state = {
    posts: {},
    liked: {}
  };

  static propTypes = {
    match: PropTypes.object.isRequired
  };

  componentDidMount() {
    const { path } = this.props.match;
    // reinstate our localstorage
    const localStorageRef = localStorage.getItem(`${path}`);

    if(localStorageRef) {
      this.setState({
        liked: JSON.parse(localStorageRef) 
      })
    }

    this.ref = base.syncState(`${path}/posts`, {
      context: this,
      state: 'posts'
    });
  };

  componentDidUpdate() {
    localStorage.setItem(
      this.props.match.path, 
      JSON.stringify(this.state.liked)
    );
  };

  componentWillUnmount() {
    base.removeBinding(this.ref);
  };

  likePost = (key) => {
    const liked = {...this.state.liked};
    liked[key] = liked[key] + 1 || 1;
    this.setState({liked});
    // console.log('post liked!');
    console.log(liked);
  };

  addPost = post => {
    // 1. take a copy of existing state
    const posts = {...this.state.posts};
    // 2. add that new post to that posts var
    posts[`post${Date.now()}`] = post;
    // 3. Set the new posts object to state
    this.setState({
      posts: posts
    });
  };

  updatePost = (key, updatedPost) => {
    // 1. take a copy of current state
    const posts = { ...this.state.posts };
    // 2. update that state
    posts[key] = updatedPost; 
    // 3. Set that to state
    this.setState({
      posts: posts
    });
  };

  deletePost = (key) => {
    // 1. Take a copy of the current state
    const posts = {...this.state.posts};
    // 2. Update that state
    posts[key] = null;
    // 3. Update state
    this.setState({ posts });
  };

  loadSamplePosts = () => {
    this.setState({ posts: samplePosts });
  };

  render() {
    return (
      <Fragment>
        <Header tagline="Travel blog" />
        <section className="content">
          <div className="wrapper">
            {Object.keys(this.state.posts).map(key => 
              <Post 
                key={key} 
                index={key} 
                details={this.state.posts[key]} 
                likePost={this.likePost[key]}
              />
            )}
          </div>
        </section>  
        <section className="content-edit">
          <ContentManagement 
            addPost={this.addPost} 
            updatePost={this.updatePost}
            deletePost={this.deletePost}
            loadSamplePosts={this.loadSamplePosts}
            posts={this.state.posts} 
            path={this.props.match.path}
          />
        </section>
        <Footer />
      </Fragment>
    )
  }
}

export default App;